import React from "react";

export default function PaymentAccepted() {
  return (
    <div>
      <div class="payments_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="sv_heading_wraper half_section_headign">
                <h4>Payment Methods</h4>
                <h3>Accepted Payment Method</h3>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
              <div class="payment_slider_wrapper">
                <div class="owl-carousel owl-theme">
                  <div class="item">
                    <div class="partner_img_wrapper float_left">
                      <img
                        src="images/partner1.png"
                        class="img-responsive"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="partner_img_wrapper float_left">
                      <img
                        src="images/partner2.png"
                        class="img-responsive"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="partner_img_wrapper float_left">
                      <img
                        src="images/partner3.png"
                        class="img-responsive"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="partner_img_wrapper float_left">
                      <img
                        src="images/partner4.png"
                        class="img-responsive"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="partner_img_wrapper float_left">
                      <img
                        src="images/partner2.png"
                        class="img-responsive"
                        alt="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
